import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { CALENDAR_TRACKING_IDS } from '../../../trackingIds/calendar-tracking-ids';
import { FilterCount } from '../popover-filter-panel-content/filter-count';

const trackingIds = CALENDAR_TRACKING_IDS.headerBarFilter;

export const CustomTrayHeader = ({ filterCount, onClose }: { onClose: () => void; filterCount?: number }) => {
  const { t } = useTranslation('scheduleCalendarFilters');
  return (
    <SurfaceHeader.Root noBorder>
      <SurfaceHeader.Row>
        <SurfaceHeader.Title css={{ gap: theme.spacing(1) }}>
          <Icon name='filter-alt' />
          {t('Filters')}
          <FilterCount count={filterCount} size='large' />
        </SurfaceHeader.Title>
        <SurfaceHeader.Actions>
          <SurfaceHeader.Icon
            onClick={onClose}
            iconName='x'
            label={t('Close')}
            trackingId={trackingIds.closeFilterButton}
          />
        </SurfaceHeader.Actions>
      </SurfaceHeader.Row>
    </SurfaceHeader.Root>
  );
};
